import React, { useEffect, useMemo, useRef, useState } from "react";
import { NavLink } from "react-router-dom";

export default function OrdersSubTabs({ tabs = [] }) {
  const scrollerRef = useRef(null);
  const [canLeft, setCanLeft] = useState(false);
  const [canRight, setCanRight] = useState(false);

  const updateArrows = useMemo(() => {
    return () => {
      const el = scrollerRef.current;
      if (!el) return;
      const max = el.scrollWidth - el.clientWidth;
      const left = el.scrollLeft;
      // small epsilon for rounding differences
      setCanLeft(left > 2);
      setCanRight(max > 2 && left < max - 2);
    };
  }, []);

  useEffect(() => {
    const el = scrollerRef.current;
    if (!el) return undefined;
    updateArrows();
    el.addEventListener("scroll", updateArrows, { passive: true });
    window.addEventListener("resize", updateArrows);
    return () => {
      el.removeEventListener("scroll", updateArrows);
      window.removeEventListener("resize", updateArrows);
    };
  }, [updateArrows, tabs.length]);

  const scrollByAmount = (dir) => {
    const el = scrollerRef.current;
    if (!el) return;
    const amount = Math.max(160, Math.floor(el.clientWidth * 0.7));
    el.scrollBy({ left: dir * amount, behavior: "smooth" });
  };

  if (!tabs.length) return null;

  return (
    <div className="so-subtabsWrap" role="tablist" aria-label="Orders sections">
      <button
        type="button"
        className={`so-subtabsArrow so-subtabsArrow--left${canLeft ? "" : " is-hidden"}`}
        aria-label="Scroll left"
        onClick={() => scrollByAmount(-1)}
      >
        <i className="ri-arrow-left-s-line" aria-hidden="true" />
      </button>

      <div className="so-subtabs" ref={scrollerRef}>
        {tabs.map((t) => (
          <NavLink
            key={t.to}
            to={t.to}
            className={({ isActive }) => `so-subtabs__tab${isActive ? " is-active" : ""}`}
            role="tab"
            aria-selected={undefined}
          >
            {t.label}
          </NavLink>
        ))}
      </div>

      <button
        type="button"
        className={`so-subtabsArrow so-subtabsArrow--right${canRight ? "" : " is-hidden"}`}
        aria-label="Scroll right"
        onClick={() => scrollByAmount(1)}
      >
        <i className="ri-arrow-right-s-line" aria-hidden="true" />
      </button>
    </div>
  );
}

